namespace Quote {

    export enum QuoteProductType {
        Accommodation = 0,
        Flight = 1,
        Transfer = 2,
        AirportParking = 3,
        AttractionTicket = 4,
        CarHire = 5
    }

    export enum CreateQuoteResponseCode {
        Success = 0,
        Unknown = 1
    }


    export interface IQuoteProductOption {
        Id: string;
        Title: string;
        Quantity: number;
        QuotedUnitCost: number;
        CurrentUnitCost: number;
        OnRequest: boolean;
        RestoreFailed: boolean;
    }

    export interface IQuoteProduct {
        Id: string;
        AvailabilityId: string;
        Type: string;
        TypeId : number;
        QuotedCost: number;
        CurrentCost: number;
        Options: IQuoteProductOption[];
        StalePrice: boolean;
        RestoreFailed: boolean;
    }



    export interface IQuoteProductHotel extends IQuoteProduct {
        Alternatives :IAlternativeHotel[];
        CheckInDate :string;
        CheckOutDate :string;
        Establishment :string;
        EstablishmentId :number;
        Rooms :string[];
    }

    export interface IAlternativeHotel {
        Board :string;
        Cost :string;
        Id :string;
        Room :number;
    }


    export interface IQuoteProductFlight extends IQuoteProduct {
        OutboundLeg :IQuoteProductFlightLeg;
        InboundLeg :IQuoteProductFlightLeg;
        Adults :number;
        ChildAges :number[];
        Alternatives :IAlternativeFlight[];
    }

    export interface IQuoteProductFlightLeg {
        Segments :IQuoteProductFlightSegment[];
    }

    export interface IQuoteProductFlightSegment {
        ArrivalCode  :string;
        ArrivalDate :string;
        Carrier :string;
        CabinName :string;
        Cabin :number;
        DepartureDate :string;
        DepartureCode  :string;
        FlightNumber :string;
        ZonedDepartureDate :string;
        ZonedArrivalDate :string;
    }

    export interface IAlternativeFlight {
        Cost :string;
        Id :string;
        InboundLeg :IQuoteProductFlightLeg;
        OutboundLeg :IQuoteProductFlightLeg;
    }


    export interface IQuoteProductTransfer extends IQuoteProduct {
        Airport :string;
        Alternatives :IAlternativeGeneric[];
        OutboundDate? :string;
        Passengers :number;
        ResortLocation :string;
        ReturnDate? :string;
        Titles :string[];
    }

    export interface IAlternativeGeneric {
        Cost :number;
        Description :string;
        Id :string;
    }


    export interface IQuoteProductCarHire extends IQuoteProduct {
        Alternatives :IAlternativeGeneric[];
        DropOffDate :string;
        DropOffPoint :string;
        PickUpPoint :string;
        PickUpDate :string;
        Titles :string[];
    }


    export interface IQuote {
        Id: string;
        Reference: string;
        BasketId: string;
        AccountingCurrency: string;
        Currency: string;
        ForHoliday: boolean;
        Products: IQuoteProduct[];
        StalePrices: boolean;
        SharedUse: boolean;
        BookingIds: number[];
        UserId: string;
        Error: any;
        Notes: any[];
    }

    export interface IQuoteCreateRequest {
        QuoteId?: string | null;
        DomainId?: number | null;
        BasketId?: string;
        SharedUse?: boolean | null;
        UserId?: string | null;
        EmailAddress?: string | null;
        SendEmail?: boolean | null;
        CultureCode?: string | null;
        TrackingTag?: string | null;
    }

    export interface ICreateQuoteResponse {
        Code: CreateQuoteResponseCode;
        Payload: IQuote;
        Error: any;
    }

    export interface IQuoteSearchModel {
        domainId: number;
        page: number;
        limit: number;
        quoteRef?: string;
        quoteNo?: number;
        reference?: string;
        userId?: string;
        externalAgentId?: number | null;
        quotedById?: number | null;
        from?: Date;
        to?: Date;
        destination?: string;
        hotelName?: string;
        sortDirection?: string;
    }

    export interface IQuoteSearchResponse {
        Results: IQuoteSearchResult[];
        Limit: number;
        Total: number;
        Page: number;
        TotalPages: number;
    }

    export interface IQuoteSearchResult {
        Id: string;
        UserId: string;
        Reference: string;
        Created: string;
        Components: IQuoteSearchComponent[];
        BookingIds: number[];
        AgentFirstName: number;
        CustomerEmailAddress: string;
        CustomerFirstName: string;
        CustomerLastName: string;
        TravelAgentFirstName: string;
        TravelAgentId: number;
        TravelAgentLastName: string;
        TravelAgentTitle: string;
    }

    export interface IQuoteSearchComponent {
        Type: string;
        TypeId: number;
        Destinations: string[];
        Detail: string;
    }

    export interface IQuoteSearch {
        searchModel: IQuoteSearchModel;
        searchResponse: IQuoteSearchResponse | null;
    }

    export interface IQuotePriceDifference{
        priceDifferenceAbs: number;
        priceDifferencePercentage: number;
    }

}
